/**
 * Lalai global Chart.js.
 *
 * Teks dalam graf dilukis pada <canvas>, jadi ia TIDAK mewarisi apa-apa
 * daripada CSS — token `--fs-*` dalam styles/typography.css tidak sampai ke
 * sini. Satu-satunya cara menetapkan saiznya ialah melalui pilihan Chart.js,
 * dan ia mesti dinyatakan sebagai nombor piksel. Itulah sebabnya fail ini
 * memakai px sedangkan seluruh UI memakai rem: bukan pengecualian gaya, tetapi
 * had medium.
 *
 * Lalai Chart.js 2 ialah 12px — lebih kecil daripada teks badan (14px) dan
 * jauh lebih kecil daripada tangga selepas revamp. Itulah sebabnya label
 * paksi, petunjuk dan tooltip pada SETIAP graf kelihatan halus. Menetapkannya
 * di sini membetulkan semua graf sekali gus; tanpa fail ini setiap `new
 * Chart()` perlu diubah satu per satu, dan graf baharu akan kembali kecil.
 *
 * NILAI di sini sepadan dengan --fs-sm (14px) apabila saiz fon akar pelayar
 * ialah 16px lalai. Ia tidak boleh mengikut tetapan fon pengguna — canvas
 * tiada konsep rem — jadi ini memang gandingan tetap, bukan terlupa.
 */
import Chart from 'chart.js';

Chart.defaults.global.defaultFontSize = 14;
Chart.defaults.global.defaultFontFamily =
  'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
Chart.defaults.global.defaultFontColor = '#37474f';

export default Chart;
